import React from 'react';

const formatTime = (timeStr) => {
  if (!timeStr) return '-';
  return timeStr.slice(0, 5);
};

const calcDuration = (start, end, breakMinutes = 0) => {
  const toMin = (t) => {
    const [h, m] = t.split(':').map(Number);
    return h * 60 + m;
  };
  const total = toMin(end) - toMin(start) - Number(breakMinutes || 0);
  if (total <= 0) return '0h 0m';
  const h = Math.floor(total / 60);
  const m = total % 60;
  return `${h}h ${m}m`;
};

const statusBadge = (status) => {
  const map = {
    draft: 'bg-gray-100 text-gray-800',
    submitted: 'bg-blue-100 text-blue-800',
    approved: 'bg-green-100 text-green-800',
    rejected: 'bg-red-100 text-red-800',
  };
  return map[status] || 'bg-gray-100 text-gray-800';
};

const TimesheetList = ({ entries, isAdmin, onEdit, onDelete, onStatusChange }) => {
  if (!entries || entries.length === 0) {
    return <p className="text-gray-500">No timesheet entries found.</p>;
  }

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Start</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">End</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Break</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Duration</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Notes</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {entries.map((entry) => (
              <tr key={entry.uuid} className="hover:bg-gray-50">
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">{entry.work_date}</td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">{formatTime(entry.start_time)}</td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">{formatTime(entry.end_time)}</td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">{entry.break_minutes || 0} min</td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">
                  {calcDuration(entry.start_time, entry.end_time, entry.break_minutes)}
                </td>
                <td className="px-4 py-3 whitespace-nowrap">
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${statusBadge(entry.status)}`}>
                    {entry.status}
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-gray-700 max-w-xs truncate" title={entry.notes}>{entry.notes || '-'}</td>
                <td className="px-4 py-3 whitespace-nowrap text-right text-sm space-x-2">
                  {['draft', 'submitted', 'rejected'].includes(entry.status) && (
                    <button
                      onClick={() => onEdit(entry)}
                      className="text-blue-600 hover:text-blue-800 font-medium"
                    >
                      Edit
                    </button>
                  )}
                  {entry.status !== 'approved' && (
                    <button
                      onClick={() => onDelete(entry.uuid)}
                      className="text-red-600 hover:text-red-800 font-medium"
                    >
                      Delete
                    </button>
                  )}
                  {isAdmin && (
                    <>
                      {entry.status !== 'approved' && (
                        <button
                          onClick={() => onStatusChange(entry.uuid, 'approved')}
                          className="text-green-600 hover:text-green-800 font-medium"
                        >
                          Approve
                        </button>
                      )}
                      {entry.status !== 'rejected' && (
                        <button
                          onClick={() => onStatusChange(entry.uuid, 'rejected')}
                          className="text-orange-600 hover:text-orange-800 font-medium"
                        >
                          Reject
                        </button>
                      )}
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TimesheetList;
